var u = (s) => {
  throw TypeError(s);
};
var h = (s, t, e) => t.has(s) || u("Cannot " + e);
var n = (s, t, e) => (h(s, t, "read from private field"), e ? e.call(s) : t.get(s)), p = (s, t, e) => t.has(s) ? u("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(s) : t.set(s, e), o = (s, t, e, r) => (h(s, t, "write to private field"), r ? r.call(s, e) : t.set(s, e), e);
import y from "axios";
function m({
  baseUrl: s,
  clientId: t,
  tokenProvider: e,
  correlationIdProvider: r
}) {
  const i = y.create({
    baseURL: s
  });
  return i.interceptors.request.use(async (c) => {
    if (e) {
      const l = await e();
      c.headers.set({
        Authorization: `Bearer ${l}`
      });
    }
    return r && c.headers.set({
      "x-correlation-id": await r()
    }), c;
  }), t && (i.defaults.headers.common.ClientId = t), i;
}
var a;
class C {
  constructor(t) {
    p(this, a);
    o(this, a, t);
  }
  async get(t, e = {}) {
    return n(this, a).get(t, e);
  }
  async post(t, e, r = {}) {
    return n(this, a).post(t, e, r);
  }
  async put(t, e, r = {}) {
    return n(this, a).put(t, e, r);
  }
  async patch(t, e, r = {}) {
    return n(this, a).patch(t, e, r);
  }
  async delete(t, e = {}) {
    return n(this, a).delete(t, e);
  }
}
a = new WeakMap();
export {
  C as HttpService,
  m as createHttpClient
};
